import React from 'react';
import quemSomosVideo from '../../videos/quem-somos.mp4';
import { useIsMobile } from '../../hooks/useIsMobile';

export default function QuemSomos() {
	const isMobile = useIsMobile();
	return (
		<>
			<div className='container' style={{ paddingTop: 60, paddingBottom: 120 }}>
				<div className='quem-title'>
					<h1>Quem somos?</h1>
				</div>
				{isMobile ? (
					<>
						<p>
							Em 2022, alunos e professores da FOUFU criaram o “Projeto Sala de Espera” para oferecer informações confiáveis sobre saúde bucal aos pacientes do HOUFU. O projeto cresceu e hoje também atua em espaços públicos, alcançando a população externa com ações educativas. A partir dessa experiência, foi criado um site para fornecer informações rápidas e acessíveis sobre saúde bucal, física e mental para adolescentes.

						</p>
						<p>
							Diante da receptividade positiva dos pacientes, percebeu-se a necessidade de expandir as ações educativas voltadas para tecnologia de informações em saúde. Assim, a ideia de desenvolver um website surgiu por ser considerado uma plataforma fácil e ágil de utilizar. Este website é uma iniciativa do diretor do Hospital Odontológico da Universidade Federal de Uberlândia (HOUFU), Professor Doutor Carlos José Soares, da Professora Doutora Jaqueline Vilela Bulgareli, mestranda Eduarda Betiati Menegazzo do Programa de Pós-Graduação da Faculdade de Odontologia da Universidade Federal de Uberlândia (PPGO-UFU), da Faculdade de Odontologia (FOUFU) e do Instituto  Nacional de Ciência e Tecnologia Saúde Oral e Odontologia do munícipio de Uberlândia (INCT-Odonto).  A proposta é oferecer aos adolescentes informações confiáveis, rápidas e de fácil acesso, essenciais para a promoção da saúde bucal, física e mental.
						</p>
					</>
				) : (
					<>

						<p>
							Em 2022, alunos da graduação em Odontologia da Universidade Federal de Uberlândia (Thiago, Maria Eduarda e Filipe), juntamente com a Professora Doutora Jaqueline Vilela Bulgareli da área da Odontologia Preventiva e Social, observaram que, embora o conceito de promoção da saúde bucal fosse amplamente discutido nas aulas, ele não estava sendo aplicado à população. Com isso, iniciou-se um projeto com o objetivo de oferecer à população atendida pelo Hospital Odontológico da Universidade Federal de Uberlândia (HOUFU) informações adequadas sobre saúde bucal. Para isso, foram elaborados materiais didáticos que abordavam os principais temas da odontologia e foram discutidos nas salas de espera pelos alunos extensionistas do Projeto “Sala de Espera”.
						</p>

						<p>
							Diante da receptividade positiva dos pacientes, percebeu-se a necessidade de expandir as ações educativas voltadas para tecnologia de informações em saúde. Assim, a ideia de desenvolver um website surgiu por ser considerado uma plataforma fácil e ágil de utilizar. Este website é uma iniciativa do diretor do Hospital Odontológico da Universidade Federal de Uberlândia (HOUFU), Professor Doutor Carlos José Soares, da Professora Doutora Jaqueline Vilela Bulgareli, mestranda Eduarda Betiati Menegazzo do Programa de Pós-Graduação da Faculdade de Odontologia da Universidade Federal de Uberlândia (PPGO-UFU), da Faculdade de Odontologia (FOUFU) e do Instituto  Nacional de Ciência e Tecnologia Saúde Oral e Odontologia do munícipio de Uberlândia (INCT-Odonto).  A proposta é oferecer aos adolescentes informações confiáveis, rápidas e de fácil acesso, essenciais para a promoção da saúde bucal, física e mental.
						</p>

					</>
				)}



				<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
					<video
						controls
						autoPlay
						style={{
							width: '100%',
							maxWidth: '800px',
							height: 'auto',
							borderRadius: '12px',
							boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
						}}
					>
						<source src={quemSomosVideo} type="video/mp4" />
						Seu navegador não suporta a tag de vídeo.
					</video>
				</div>



			</div>
		</>
	);
}